<dynamic-form
  *ngIf="formGroupIsOk && columns && columns.length > 0"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  (onRowSelected)="onChange($event)">
  <ng-container class="content">
    <div class="page">
      <div *ngIf="HasDetailLedger1">
        <ssg-select
          name="DetailLedger1"
          [multiple]="true"
          [group]="formGroup"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger1' | translate"
          apiName="DetailLedgerKind/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id"
          userClass="large">
        </ssg-select>
      </div>
      <div *ngIf="HasDetailLedger2">
        <ssg-select
          name="DetailLedger2"
          [multiple]="true"
          [group]="formGroup"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger2' | translate"
          apiName="DetailLedgerKind/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="HasDetailLedger3">
        <ssg-select
          name="DetailLedger3"
          [multiple]="true"
          [group]="formGroup"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger3' | translate"
          apiName="DetailLedgerKind/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="HasDetailLedger4">
        <ssg-select
          name="DetailLedger4"
          [multiple]="true"
          dropdownPosition="auto"
          [group]="formGroup"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger4' | translate"
          apiName="DetailLedgerKind/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="HasDetailLedger5">
        <ssg-select
          name="DetailLedger5"
          [multiple]="true"
          [group]="formGroup"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger5' | translate"
          apiName="DetailLedgerKind/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="HasDetailLedger6">
        <ssg-select
          name="DetailLedger6"
          [multiple]="true"
          [group]="formGroup"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger6' | translate"
          apiName="DetailLedgerKind/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="HasDetailLedger7">
        <ssg-select
          name="DetailLedger7"
          [multiple]="true"
          [group]="formGroup"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger7' | translate"
          apiName="DetailLedgerKind/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
    </div>
  </ng-container>
</dynamic-form>
